/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportsCogsProductService
 * @description Data access service for POS Items
 */
angular.module('mercury.modules.reports.cogs')
.factory('ReportsCogsProductService', function() {

  /**
   * Take the combined results array and return the results for either a single category, or for all categories combined
   */
  var parseResults = function(allResults, categoryNames) {
    var reportLines = [];
    var chartLines = [];
    var salesExTotal = 0;
    var salesExTotalExcludingUnlinked = 0;
    var qtySoldTotalExcludingUnlinked = 0;
    var costTotal = 0;
    var discountsTotal = 0;

    allResults.forEach(function(item) {
      if (categoryNames.length == 0 || categoryNames.includes(item.posItemCategoryName)) {
        var lineData = {
          posItemIdentifier: item.posItemIdentifier,
          posItemName: item.posItemName,
          quantitySold: item.quantitySold,
          salesEx: item.salesExcludeTax,
          cost: item.cost,
          costPerc: item.salesExcludeTax == 0 ? 0 : item.cost / item.salesExcludeTax * 100,
          discounts: item.discounts,
          grossMargin: item.salesExcludeTax - item.cost
        };
        reportLines.push(lineData);

        // Prepare data for the chart, this is all data that is linked to a stock item, and
        // which has a positive value for the gross margin.
        if (lineData.cost && lineData.grossMargin > 0) {
          chartLines.push(lineData);
        }

        salesExTotal += item.salesExcludeTax;
        if (item.cost !== null) {
          salesExTotalExcludingUnlinked += item.salesExcludeTax;
          qtySoldTotalExcludingUnlinked += item.quantitySold;
          costTotal += item.cost;
          discountsTotal += item.discounts;
        }
      }
    });

    var costPercTotal = salesExTotalExcludingUnlinked == 0 ? 0 : costTotal / salesExTotalExcludingUnlinked * 100;

    return {
      lines: reportLines,
      chartLines: chartLines,
      salesExTotal: salesExTotal,
      salesExTotalExcludingUnlinked: salesExTotalExcludingUnlinked,
      qtySoldTotalExcludingUnlinked: qtySoldTotalExcludingUnlinked,
      costTotal: costTotal,
      costPercTotal: costPercTotal,
      discountsTotal: discountsTotal
    };
  };

  return {
    parseResults: parseResults
  };
});
